import { useRef, useCallback } from 'react';

function useMutableCallback<T extends (...args: any[]) => any>(callback: T) {
  const changePathRef = useRef(callback);
  changePathRef.current = callback;
  return useCallback(((...args: any[]) => changePathRef.current(...args)) as T, []);
}

export default useMutableCallback;
